import * as React from "react";
import MonopatinContainer from "../containers/seguro-de-monopatin-container";

export default function MonopatinPage({ data }) {
  return <MonopatinContainer data={data}></MonopatinContainer>;
}
